import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/base/base.service';
import { DistributionCalendarBlueprint, DistributionCalendar } from './distribution-calendars.models';
import { HttpRequestType, RequestService } from '../../../core/request.service';
import { Constants, SearchOperations } from '../../../app.constants';
import { AlertService } from '../../../core/alert.service';
import { UtilityService } from 'src/app/core/utility.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionCalendarsService extends BaseService {

  constructor(protected requestService: RequestService, private alertService: AlertService, private utilityService: UtilityService) {
    super(requestService);
  }

  public generateDistributionCalendar(data: DistributionCalendarBlueprint, onSuccess: Function, onFail: Function = null) {
    this.requestService.createRequest(HttpRequestType.Post, `${Constants.contextPath}/distribution-calendars/generate`, data, null, (response: DistributionCalendar[]) => {
      onSuccess(response);
    }, (error) => {
      if(onFail != null)
        onFail(error);
      else 
        this.alertService.error(error, true);
    })
  }

  public getCaledarData(dateFrom: Date, dateTo: Date, onSuccess: Function) {
    this.requestService.createRequest(HttpRequestType.Get, `${Constants.contextPath}/distribution-calendars/list?${SearchOperations.KEY_SEARCH}=${SearchOperations.LEFT_PARENTHESES_READABLE}date${SearchOperations.GREATER_THAN_OR_EQUAL}${this.utilityService.formatDateToYYYYMMDD(dateFrom)}${SearchOperations.SPLIT_SINGLE_OPERATION}date${SearchOperations.LESS_THAN_OR_EQUAL}${this.utilityService.formatDateToYYYYMMDD(dateTo)}${SearchOperations.RIGHT_PARENTHESES_READABLE}`, null, null, (response: DistributionCalendar[]) => {
      onSuccess(response);
    });
  }
}
